var exports = {
  "U": "x4ddf2309--0c4f48--buttons",
};

module.exports = exports;
